import { loadStripe } from "@stripe/stripe-js"

import { toast } from "@/components/toast"
import { env } from "@/env"
import { api } from "@/lib/api"
import { captureError } from "@/lib/capture-error"

export function useAddPaymentMethod() {
	const updatePayment = api.workspace.updatePayment.useMutation()

	return async () => {
		try {
			const sessionId = await updatePayment.mutateAsync()
			if (!sessionId) return
			const stripe = await loadStripe(env.VITE_STRIPE_PUBLISHABLE_KEY)
			await stripe?.redirectToCheckout({ sessionId })
		} catch (error) {
			captureError(error, {
				domain: "billing",
				action: "open add payment method checkout",
			})
			toast.error({
				title: "Couldn't open the payment form",
				description: "Add your card from Settings, Plans instead.",
			})
		}
	}
}
